import { Position } from '@xyflow/react';
import BhHandle from '../flowkit/handle';
import { BhFlowNode, BhFlowTitle, BhFlowSubtitle } from '../flowkit/flowNode';
import { FlowInGlyph, FlowOutGlyph, DataGlyph, ProviderGlyph } from '../flowkit/glyphs';
import Components from '../controls/common/components';

const components = new Components();

function ProcessorNode({ data, isConnectable, selected }) {
  const portByType = {
    flow_input: [],
    flow_output: [],
    data_input: [],
    data_output: [],
    provider_input: [],
    provider_reference: [],
    data_reference: [],
  };
  for (const port of data.manifest['ports']) {
    portByType[port['category']].push(port);
  }

  const handles = (
    <>
      {portByType.flow_input.length > 0 && (
        <BhHandle mode="fixed" type="target" id="flow_input" style={{ left: 20 }}
          isConnectable glyph={<FlowInGlyph />} />
      )}

      {portByType.flow_output.length > 0 && (
        <BhHandle mode="fixed" type="source" position={Position.Bottom} id="flow_output" style={{ left: 20 }}
          isConnectable glyph={<FlowOutGlyph />} />
      )}

      {portByType.data_input.length > 0 && (
        <BhHandle mode="fixed" type="source" id="data_input" style={{ left: 'auto', right: 5 }}
          isConnectable glyph={<DataGlyph />} />
      )}

      {portByType.data_output.length > 0 && (
        <BhHandle mode="fixed" type="source" position={Position.Bottom} id="data_output"
          style={{ left: 'auto', right: 5 }} isConnectable glyph={<DataGlyph />} />
      )}

      {portByType.provider_input.length > 0 && (
        <BhHandle mode="fixed" type="source" id="provider_input" position={Position.Left}
          isConnectable glyph={<ProviderGlyph />} />
      )}

      {portByType.provider_reference.length > 0 && (
        <BhHandle mode="fixed" type="target" id="provider_reference" position={Position.Right}
          isConnectable glyph={<ProviderGlyph />} />
      )}

      {portByType.data_reference.length > 0 && (
        <BhHandle mode="fixed" type="target" id="data_reference" position={Position.Left}
          isConnectable glyph={<ProviderGlyph />} />
      )}
    </>
  );

  return (
    <BhFlowNode selected={selected} icon={components.getComponentIcon(data.processor.type)} attachments={handles}>
      <BhFlowTitle>{data.processor.name}</BhFlowTitle>
      <BhFlowSubtitle tone="pink">{data.processor.type}</BhFlowSubtitle>
    </BhFlowNode>
  );
}

export default ProcessorNode;
